export default __webpack_public_path__ + "static/media/pot2.abcb51d4.svg";